import { FullIM } from "./fullIM";
import { ChatWin } from "./chatWin";

export const WebIM = {
    FullIM,
    ChatWin
};
